import { render, staticRenderFns } from "./CarFoundBox.vue?vue&type=template&id=a0be0ece&scoped=true&"
import script from "./CarFoundBox.vue?vue&type=script&lang=js&"
export * from "./CarFoundBox.vue?vue&type=script&lang=js&"
import style0 from "./CarFoundBox.vue?vue&type=style&index=0&id=a0be0ece&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0be0ece",
  null
  
)

export default component.exports